import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    Label,
    LabelList
} from 'recharts';
import styles from './verticalBarGraph.module.css';

const CustomLegend = (props) => {
    const { payload } = props;
    return (
        <div style={{ display: 'flex', justifyContent: 'left', padding: '10px' }}>
            {payload.map((entry, index) => {
                const { value, color } = entry;
                return (
                    <span
                        key={`item-${index}`}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            padding: '0 10px',
                        }}
                    >
                        <span
                            style={{
                                backgroundColor: color,
                                width: '6px',
                                height: '12px',
                                display: 'inline-block',
                                borderRadius: '2px',
                            }}
                        />
                        <span style={{ color: '#4D4D4F' }}>{value}</span>
                    </span>
                );
            })}
        </div>
    );
};

const ExternalLabelList = (props) => {
    const { x, y, width, height, value, dataKey } = props;

    if (!value || value === 0) return null;

    const showExternally = width < 50;
    const barColor = dataKey === "Impacted Plan" ? "#2b2b2b" : "#2b2b2b";

    return (
        <g>
            <text
                x={showExternally ? x + width + 5 : x + width / 2}
                y={y + height / 2}
                fill={showExternally ? barColor : "white"}
                textAnchor={showExternally ? "start" : "middle"}
                dominantBaseline="middle"
                fontSize={10}
                fontWeight={400}
            >
                {value.toFixed(0)}
            </text>
        </g>
    );
};


const HorizontalBarGraph = ({ data }) => {

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div className={styles.customTooltip}>
                    {payload.length > 0 && (
                        <>
                            {payload[0].payload["CBU Description"] && (
                                <p className={styles.tooltipItem} >
                                    <span style={{ fontWeight: 600 }}>CBU Description:</span> {payload[0].payload["CBU Description"]}
                                </p>
                            )}
                        </>
                    )}
                    {payload.map((item, index) => (
                        <p key={index} className={styles.tooltipItem}>
                            <span style={{ fontWeight: 600 }}>{item.name}</span> : {`${item.value.toFixed(0)} ${item.payload["Unit of Measure"]} `}
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    const recordsCount = data?.length || 0;
    const barHeight = 15;
    const chartHeight = recordsCount * barHeight + 200;
    const legendStyle = {
        fontSize: '10px',
        paddingTop: '15px',
        color: '#4D4D4F',
    };

    return (
        <ResponsiveContainer width="100%" height={chartHeight}>
            <BarChart
                data={data}
                layout="vertical"
                margin={{
                    top: 10,
                    right: 10,
                    left: 20,
                    bottom: 10,
                }}
            >
                <>
                    {/* <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={true} stroke="#CCC" horizontalPoints={10} /> */}
                    <XAxis type="number" domain={[0, 'auto']} tickLine={false} className={styles.BarLabelCBU} axisLine={{ strokeDasharray: "3 3", stroke: "#ccc" }}>
                        <Label value="Quantity" position="insideBottom" offset={-5} className={styles.axisLabel} />
                    </XAxis>
                    <YAxis dataKey="CBU" type="category" className={styles.BarLabelCBU} tickLine={false} axisLine={{ strokeDasharray: "3 3", stroke: "#ccc" }}>
                        <Label value="Impacted CBUs" angle={-90} position="insideLeft" className={styles.axisLabel} offset={-10} style={{ textAnchor: 'middle' }} />
                    </YAxis>
                    <Tooltip
                        content={<CustomTooltip />}
                        wrapperStyle={{
                            fontSize: '12px',
                            padding: '6px',
                        }}
                    />
                    <Legend verticalAlign="bottom" align="left" wrapperStyle={legendStyle} content={<CustomLegend />} />
                    <Bar dataKey="Projected Production" name="Projected Production" fill="#00B190" barSize={20} stackId="a" radius={[0, 0, 0, 0]}>
                        <LabelList
                            dataKey="Projected Production"
                            position="inside"
                            className={styles.labelList}
                            formatter={(value) => value !== 0 ? value?.toFixed(0) : ''}
                        />
                    </Bar>
                    <Bar dataKey="Impacted Plan" name="Impacted Plan" fill="#FF544F" barSize={20} stackId="a" radius={[0, 4, 4, 0]}>
                        <LabelList
                            dataKey="Impacted Plan"
                            position="insideRight"
                            className={styles.labelList}
                            formatter={(value) => value !== 0 ? value?.toFixed(0) : ''}
                            content={<ExternalLabelList />}
                        />
                    </Bar>
                </>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default HorizontalBarGraph;
